import { render, staticRenderFns } from "./ProjectPaymentPlans.vue?vue&type=template&id=60754904"
import script from "./ProjectPaymentPlans.vue?vue&type=script&lang=js"
export * from "./ProjectPaymentPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports